<template>
  <svg
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="4.06201" cy="3.76578" r="3.28711" fill="currentColor" />
  </svg>
</template>
